var map = {
	"./Logo-white.png": "2Dq0",
	"./Logo.png": "oxRg",
	"./banner-bg.png": "1IKm",
	"./favicon.png": "Yhqy",
	"./icon-play.svg": "/Bzs",
	"./icon-search.svg": "daJP",
	"./illustration-about.png": "oBUu",
	"./illustration1.png": "2qwN",
	"./illustration2-mobile.png": "WwiZ",
	"./illustration2.png": "Mntb",
	"./langojango-amharic-language-phrasebook.png": "L6FJ",
	"./langojango-arabic-language-phrasebook.png": "MwbL",
	"./langojango-brazillian-portugugese-language-phrasebook.png": "Jhe8",
	"./langojango-bulgarian-language-phrasebook.png": "S0X0",
	"./langojango-cantonese-language-phrasebook.png": "B0VA",
	"./langojango-croatian-language-phrasebook.png": "B+qS",
	"./langojango-czech-language-phrasebook.png": "jAHE",
	"./langojango-finnish-language-phrasebook.png": "YUOc",
	"./langojango-french-language-phrasebook.png": "RJLk",
	"./langojango-german-language-phrasebook.png": "m5FC",
	"./langojango-hebrew-language-phrasebook.png": "MtkJ",
	"./langojango-hungarian-language-phrasebook.png": "Q3pr",
	"./langojango-igbo-language-phrasebook.png": "lqj0",
	"./langojango-italian-language-phrasebook.png": "AKOi",
	"./langojango-khmer-language-phrasebook.png": "755D",
	"./langojango-korean-language-phrasebook.png": "i4R3",
	"./langojango-luganda-language-phrasebook.png": "FoOk",
	"./langojango-mandarin-language-phrasebook.png": "3aYY",
	"./langojango-polish-language-phrasebook.png": "cuGk",
	"./langojango-portuguese-language-phrasebook.png": "+eeX",
	"./langojango-russian-language-phrasebook.png": "Au+i",
	"./langojango-serbian-language-phrasebook.png": "E9UL",
	"./langojango-spanish-language-phrasebook.png": "7bzz",
	"./langojango-swahili-language-phrasebook.png": "U/5K",
	"./langojango-swedish-language-phrasebook.png": "htbt",
	"./langojango-tagalog-language-phrasebook.png": "wGTf",
	"./langojango-thai-language-phrasebook.png": "MVVY",
	"./langojango-turkish-language-phrasebook.png": "0rUN",
	"./langojango-twi-language-phrasebook.png": "MzC8",
	"./langojango-vietnamese-language-phrasebook.png": "IGpr",
	"./langojango-yoruba-language-phrasebook.png": "BeJs",
	"./video-thumbnail.png": "DIR8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";